import React from "react";
import styles from "./UploadExcelModal.module.css";
import MultipleSheets from "../../../assets/icons/MultipleSheets.png";
import MultipleFiles from "../../../assets/icons/MultipleFiles.png";
import { BackArrowButton, CloseButton } from "../../button/Button";

const UploadExcelModal = ({ onClose, onBack, onSelectUploadType }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={styles.title}>
              Add Fixed Assets Register (Upload Excel)
            </h2>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.content}>
          <div 
            className={styles.cardContainer}
            onClick={() => onSelectUploadType("multipleFiles")}
          >
            <div className={styles.imageWrapper}>
              <div className={styles.iconPlaceholder}>
                <img src={MultipleFiles} alt="MultipleFiles"/>
              </div>
            </div>
            <div className={styles.belowContainer}>
              <h3 className={styles.cardTitle}>
                Upload as multiple excel files
              </h3>
              <p className={styles.cardDescription}>
                Make sure only one sheet is present! If one file is uploaded at
                a time
              </p>
            </div>
          </div>

          <div 
            className={styles.cardContainer}
            onClick={() => onSelectUploadType("multipleSheets")}
          >
            <div className={styles.imageWrapper}>
              <div className={styles.iconPlaceholder}>
                <img src={MultipleSheets} alt="Multiplesheets"/>
              </div>
            </div>
            <div className={styles.belowContainer}>
              <h3 className={styles.cardTitle}>
                Upload as multiple excel Sheets
              </h3>
              <p className={styles.cardDescription}>
                Make sure only one sheet is present! If one file is uploaded at
                a time
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadExcelModal;